/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Smart_Mantis_BubbleInputs */

const en_brave_smart_mantis_bubble = /** @type {(inputs: Brave_Smart_Mantis_BubbleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributes`)
};

const de_brave_smart_mantis_bubble = /** @type {(inputs: Brave_Smart_Mantis_BubbleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkmale`)
};

/**
* | output |
* | --- |
* | "Attributes" |
*
* @param {Brave_Smart_Mantis_BubbleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const brave_smart_mantis_bubble = /** @type {((inputs?: Brave_Smart_Mantis_BubbleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Smart_Mantis_BubbleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_brave_smart_mantis_bubble(inputs)
	return de_brave_smart_mantis_bubble(inputs)
});